module.exports = __webpack_public_path__ + "img/headers-fresh.30a940ad.png";